import { render, staticRenderFns } from "./HelsinkiUsersTable.vue?vue&type=template&id=b60b4bcc&scoped=true"
import script from "./HelsinkiUsersTable.vue?vue&type=script&lang=js"
export * from "./HelsinkiUsersTable.vue?vue&type=script&lang=js"
import style0 from "./HelsinkiUsersTable.vue?vue&type=style&index=0&id=b60b4bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60b4bcc",
  null
  
)

export default component.exports